import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
const faqs = [{
  question: 'What types of junk do you remove?',
  answer: 'We handle almost everything, including furniture, appliances, construction debris, yard waste, and general household junk. We do not take hazardous materials like wet paint, chemicals, or asbestos.'
}, {
  question: 'How does your pricing work?',
  answer: 'Our pricing is based on the volume of space your junk takes up in our trucks. We provide upfront, transparent quotes before we start any work, so there are no surprises.'
}, {
  question: 'Are you licensed and insured?',
  answer: 'Yes, Drop Zone Cleanup Co. is fully licensed and insured. We prioritize safety and professionalism on every job site.'
}, {
  question: 'Do you offer same-day service?',
  answer: 'We often have same-day or next-day availability depending on our current deployment schedule. Call us directly for the fastest response.'
}, {
  question: 'Do you recycle or donate items?',
  answer: 'Absolutely. We sort through the items we collect to ensure anything salvageable is donated to local charities, and recyclables are processed properly. We aim to keep as much out of the landfill as possible.'
}];
export function FAQ() {
  return <section id="faq" className="py-24 bg-card border-t border-border" data-id="element-10">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h2 className="text-primary font-bold tracking-widest uppercase text-sm mb-3 flex items-center justify-center gap-2" data-id="element-13">
            <span className="w-8 h-[2px] bg-primary" data-id="element-14"></span>
            Intel
            <span className="w-8 h-[2px] bg-primary" data-id="element-15"></span>
          </h2>
          <h3 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight" data-id="element-16">
            Frequently Asked Questions
          </h3>
        </div>

        <Accordion type="single" collapsible className="w-full" data-id="element-17">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border" data-id="element-18">
              <AccordionTrigger className="text-left font-heading font-bold text-lg uppercase tracking-wide hover:text-primary transition-colors" data-id="element-19">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed" data-id="element-20">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}